import { Button, Chip, DateSpan, FileItem, GenericSuspense, Metadata, Avatar, useFileUrl, useTranslation, useTranslationRoute, useTranslations, useUrlParamsValueToString, useRuntimeEnv, useUserProfilePicture, useDisplayAlert, useNumberFormat } from "@harea/component"
import { RefuseDayOffDialog } from "./RefuseDayOffDialog"
import { TTimeOff } from "@harea/component"
import { Link, Outlet, useParams } from "react-router-dom"
import { ReactNode, useCallback, useMemo, useState } from "react"
import { useValidateDayOffMutation } from "hooks/useValidateDayOffMutation"
import { useRefuseDayOffMutation } from "hooks/useRefuseDayOffMutation"
import { useAppointmentDetailsEditLink } from "hooks/useAppointmentDetailsEditLink"
import { useExportDayOffMutation } from "hooks/useExportDayOffMutation"
import { AppointmentDetailsType } from "./AppointmentDetailsType"
import { useTimeOffQuery } from "hooks/useTimeOffQuery"
import { VacationStatus } from "./VacationStatus"
import { useContractManagerQuery } from "hooks/useContractManagerQuery"
import moment from "moment"
import { useQueryClient } from "react-query"
import { useTimeOffInvalidateQuery } from "hooks/useTimeOffInvalidateQuery"
import { useDailyQuotaLeaveTypes } from "hooks/useDailyQuotaLeaveTypes"
import { MaternityDetails } from "./MaternityDetails"


export const AppointmentDetails = (props: Props) => {
  const [
    CREATOR,
    STATUS,
    CLOSED,
    OPENED,
    CREATED_AT,
    DEMAND_DATE,
    DATE_BEGIN,
    DATE_END,
    LABELS,
    USERS,
    DESCRIPTION,
    ATTACHMENT,
    METADATA,
    ARCHIVED,
    EDIT,
    MILESTONE,
    USER,
    REPETITION,
    VALIDATE,
    APPROVE,
    REFUSE,
    PRINT,
    EMPLOYEE,
    POSITION,
    REMAINDER,
    TOTAL_DAYS,
    REASON,
    REFUSAL_REASON,
    EMPLOYEE_DETAILS,
    TOTAL_HOURS,
    ANNUAL_REMAINING_QUOTA,
    PAYROLL_DEDUCTION_AMOUNT,
    TREATMENT,
    TREATMENT_EXCEPTION,
    TREATMENT_PAYROLL,
    TREATMENT_NEGATIVE_BALANCE
    ] = useTranslations(i18n)
    const { id } = useParams()
    const { invalidateQuery } = useTimeOffQuery(parseInt(id), true, props.disableDetailsQuery !== true);
    const invalidateTimeOffsQuery = useTimeOffInvalidateQuery()
    const editLink = useAppointmentDetailsEditLink(props.type)
    const fileUrl = useFileUrl()
    const tr = useTranslationRoute()
    const formatCurrency = useNumberFormat({ style: "currency", currency: "MGA" })
    const exportDayOff = useExportDayOffMutation()
    const { runtimeEnv } = useRuntimeEnv()
    const userRole = runtimeEnv?.user?.role as string
    const canRefuse = ['ADMIN', 'SUPER_ADMIN', 'MANAGER', 'DIRECTOR_HR'].includes(userRole)
    const canApprove = ['ADMIN', 'SUPER_ADMIN', 'MANAGER', 'DIRECTOR_HR'].includes(userRole) && ( props?.status !== 'approved' || (props as any)?.status !== 'refused' )
    // const canApprove = userRole === 'MANAGER'
    const canValidate = ['ADMIN', 'SUPER_ADMIN', 'DIRECTOR_HR'].includes(userRole) && ( props?.status !== 'validated' || (props as any)?.status !== 'refused' )
    console.log(userRole, ['ADMIN', 'SUPER_ADMIN', 'DIRECTOR_HR'].includes(userRole))

    const currentUserDepartmentId = (runtimeEnv?.user as any)?.department?.id
    const employeeDepartmentId = props?.employee?.department?.id
    // const isSameDepartment = currentUserDepartmentId === employeeDepartmentId
    // const canManageRequest = (canRefuse || canApprove || canValidate) && (canValidate || isSameDepartment)
    console.log('props', props)
    const { data, invalidateQuery: invalidateContractQuery } = useContractManagerQuery(props?.employee?.id, props?.type?.designation as any, true);
    const queryClient = useQueryClient()
    const [refuseDialogOpen, setRefuseDialogOpen] = useState(false)

    const validateMutation = useValidateDayOffMutation()
    const refuseMutation = useRefuseDayOffMutation()
    const userProfilePictureUrl = useUserProfilePicture()
    const addAlert = useDisplayAlert()

    const [VALIDATE_ERROR] = useTranslations([
        "Harea.Project.DayOff.Validate.Error.Message",
    ])

    // Le formulaire de refus enregistre un code (ex. "staffing_needs") ; un motif libre reste affiché tel quel.
    const t = useTranslation()
    const refusalReason: string | undefined = (props as any).refusalReason
    const refusalReasonLabel = REFUSAL_REASON_CODES.includes(refusalReason ?? "")
        ? t(`std_${refusalReason}`)
        : refusalReason

    const remainingSolde = (data?.leaveBalance as any)?.congeSolde?.toString()

    const dailyQuotaTypes = useDailyQuotaLeaveTypes()

    const handleApproveOrValidate = () => {
        if (!props?.id) return
        const p: any = props
        const data: Record<string, any> = {}
        if (p?.negativeBalance) data.negativeBalance = true
        if (p?.deductFromPay) data.deductFromPay = true
        if (p?.exception) data.exception = true
        validateMutation.mutate({ id: props.id, data }, {
            onSuccess: () => { 
              invalidateQuery();
              invalidateTimeOffsQuery();
              queryClient.invalidateQueries('App.bo.ContractManagerQuery');
            },
            onError: () => {
              addAlert({ text: VALIDATE_ERROR, type: 'danger', dismissTimeout: 10000 })
            },
        })
    }

  const handleRefuse = () => {
        if (!props?.id) return
        setRefuseDialogOpen(true)
    }

    const handleRefuseConfirm = (reason: string) => {
        if (!props?.id) return
        refuseMutation.mutate({ id: props.id, reason }, {
            onSuccess: () => {
                invalidateTimeOffsQuery();
                invalidateQuery();
                invalidateContractQuery?.();
                setRefuseDialogOpen(false);
            },
        })
    }

  const ticketStatus = useMemo(() => {
    if (props?.dateArchive) {
            return ARCHIVED
    }

        return props?.isClosed ? CLOSED : OPENED
    }, [props])

    const getEndIcon = useCallback((approval) => {
      if (approval?.isApproved) {
            return "fa-circle-check text-success"
      }

      if (approval?.isRefused) {
            return "fa-circle-xmark text-danger"
      }
    }, [props])

    const duration = useMemo(() => {
        if (!props?.dateBegin || !props?.dateEnd) return undefined;
        return props?.countWorkingDays
    }, [props?.dateBegin, props?.dateEnd, props?.countWorkingDays]);

    const treatmentLabel = useMemo(() => {
        const p: any = props;
        if (p?.unpaidLeaveMode === 'EXCEPTION' || p?.isExceptionalPaid || p?.exception) return TREATMENT_EXCEPTION;
        if (p?.unpaidLeaveMode === 'PAYROLL' || p?.deductFromPay) return TREATMENT_PAYROLL;
        if (p?.unpaidLeaveMode === 'BALANCE' || p?.negativeBalance) return TREATMENT_NEGATIVE_BALANCE;
        return null;
    }, [props]);

    const hasApproved = props?.approvals?.some((item) => item?.isApproved)

  const editable = props.isEditable && !['validated', 'refused'].includes(props?.status)

  const handleDayoffExport = () => {
    exportDayOff.mutate(props?.id?.toString())
  }

    const disabledValidation = props?.status === "refused" ||
                  props?.status === "validated" ||
                  !hasApproved ||
                  !props?.id ||
                  validateMutation.isLoading

    const disabledApprobation = props?.status === "refused" ||
                  props?.status === "validated" ||
                  props?.status === "approved" ||
                  !props?.id ||
                  validateMutation.isLoading

  const designation = props?.type?.designation
  const isMaternity = designation === "MATERNAL" || designation === "MATERNAL_ASSISTANCE"
                

  return (
    <div className="flex flex-col gap-7">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col">
          <div className="flex justify-between flex-wrap">
            <h3 className="flex gap-4 items-center">
              <AppointmentDetailsType {...props} />
            </h3>
            <div className="flex gap-2">
              {props.id && (
                <Button
                  className="btn-default"
                  startIcon="fa-print"
                  label={PRINT}
                  onClick={handleDayoffExport}
                  isLoading={exportDayOff.isLoading}
                />
              )}
              {editable && (
                <>
                  <Link to={editLink}>
                    <Button
                      className="btn-default"
                      startIcon="fa-pen"
                      label={EDIT}
                    />
                  </Link>
                  {props.toolbox}
                </>
              )}
            </div>
          </div>
        </div>
        <div className="flex justify-between">
          <Metadata
            label={LABELS}
            labelProps={{ 
              className: 'mr-[15px] !w-auto'
            }}
            value={
              props.labels?.length > 0 ? (
                <div className="flex gap-2 flex-wrap">
                  {props.labels?.map((item, index) => (
                    <Chip
                      key={index}
                      className="bg-white"
                      label={item.value}
                      color={item.color}
                    />
                  ))}
                </div>
              ) : undefined
            }
          />
          <Metadata 
            label={STATUS}
            value={<VacationStatus {...props} />}
            labelProps={{ 
              className: 'mr-[15px] !w-auto'
            }}
          />
          <div className="flex gap-5 flex-wrap">
            <Metadata
              label={CREATOR}
              labelProps={{ 
                className: 'mr-[15px] !w-auto'
              }}
              value={
                <Link to={tr(`admin/user/${props?.userCreator?.employee.id}`)}>
                  <Chip
                    userId={props?.userCreator?.id}
                    label={props?.userCreator?.employee?.fullName}
                  />
                </Link>
              }
            />
          </div>
        </div>

  <div />
</div>
      <div>
        <div className="flex flex-col gap-2">
          <h3 className="mb-2">{EMPLOYEE_DETAILS}</h3>
          <div className="grid grid-cols-2 gap-2 divide-x-2">
            <div className="px-4">
              {props.employee && (
                <div className="flex items-start gap-2">
                  <Link
                    to={`user/${props?.employee?.id}`}
                    className="flex items-center gap-3"
                  >
                    <Avatar
                      src={userProfilePictureUrl(props?.employee?.id)}
                      fullName={props?.employee?.fullName}
                      size="lg"
                    />
                  </Link>
                  <div className="flex flex-col">
                    <span className="font-medium">
                      {props?.employee?.fullName}
                    </span>
                    <span className="text-xs text-muted">
                      {(props?.employee as any)?.jobPosition?.value ??
                        (props?.employee as any)?.position ??
                        props?.employee?.department?.designation ??
                        ""}
                    </span>
                    <div className="mt-2 flex flex-col">
                      <div className="flex gap-3 items-center">
                        <span className="text-xs text-muted">{POSITION}</span>
                        <span className="font-medium">
                          {(data?.jobPosition as any)?.value ?? "-"}
                        </span>
                      </div>
                      <div className="flex gap-3 items-center">
                        <span className="text-xs text-muted">{REMAINDER}</span>
                        <span className="font-medium">{remainingSolde}</span>
                      </div>
                      {props?.type?.designation && dailyQuotaTypes.includes(props.type.designation) && (
                        <div className="flex gap-3 items-center">
                          <span className="text-xs text-muted">{ANNUAL_REMAINING_QUOTA}</span>
                          <span className="font-medium">
                            {(data?.leaveBalance as any)?.getRemainingQuota ?? 0}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="flex flex-col gap-4 px-4">
              {props.createdAt && (
                <Metadata
                  label={DEMAND_DATE}
                  className="grid grid-cols-[130px_1fr] gap-4 items-center"
                 
                  value={
                    <div className="flex items-center gap-2 flex-wrap min-w-0">
                      <span className="inline-flex items-center gap-2 rounded-full bg-default px-3 py-1 text-xs text-foreground whitespace-nowrap">
                        <i className="fa-solid fa-clock text-muted-foreground" />
                        <DateSpan value={new Date(parseInt(props.createdAt))} format="LL" />
                      </span>
                    </div>
                  }
                />
              )}
              {props.dateBegin && (
                <Metadata
                  label={DATE_BEGIN}
                  className="grid grid-cols-[130px_1fr] gap-4 items-center"
                 
                  value={
                    <div className="flex items-center gap-2 flex-wrap min-w-0">
                      <Chip
                        startIcon="fa-clock"
                        className="bg-default shrink-0"                        label={<DateSpan value={props.dateBegin} format="LL" />}
                      />
                      {(props.hourBegin || props.hourEnd) && (
                        <span className="text-sm font-medium text-muted-foreground whitespace-nowrap">
                          {props.hourBegin}
                        </span>
                      )}
                    </div>
                  }
                />
              )}

              {props.dateEnd && (
                <Metadata
                  label={DATE_END}
                  className="grid grid-cols-[130px_1fr] gap-4 items-center"
                 
                  value={
                    <div className="flex items-center gap-2 flex-wrap min-w-0">
                      <Chip
                        startIcon="fa-clock"
className="bg-default shrink-0"                        label={<DateSpan value={props.dateEnd} format="LL" />}
                      />
                      {props.hourEnd && (
                        <span className="text-sm font-medium text-muted-foreground whitespace-nowrap">
                          {props.hourEnd}
                        </span>
                      )}
                    </div>
                  }
                />
              )}
              {duration !== undefined && (
                  <Metadata
                      label={TOTAL_DAYS}
                      className="grid grid-cols-[130px_1fr] gap-4 items-center"
                      
                      value={<span className="font-medium">{duration.toString()}</span>}
                  />
              )}
              {treatmentLabel && (
                  <Metadata
                      label={TREATMENT}
                      className="grid grid-cols-[130px_1fr] gap-4 items-center"
                      value={<span className="font-medium">{treatmentLabel}</span>}
                  />
              )}
              {(props as any)?.payrollDeductionAmount != null && (
                  <Metadata
                      label={PAYROLL_DEDUCTION_AMOUNT}
                      className="grid grid-cols-[130px_1fr] gap-4 items-center"
                      value={<span className="font-medium text-danger">{formatCurrency((props as any)?.payrollDeductionAmount)}</span>}
                  />
              )}
            </div>
          </div>

          <div className="flex gap-4 flex-wrap">
            {props.approvals?.length > 0 && (
              <Metadata
                label={USERS}
                className="flex-col items-start"
                value={
                  <div className="flex gap-2 flex-wrap">
                    {props.approvals.map((item) => (
                      <Link to={`user/${item?.approver?.id}`}>
                        <Chip
                          userId={item?.approver?.id}
                          label={item?.approver?.fullName}
                          endIcon={getEndIcon(item)}
                        />
                      </Link>
                    ))}
                  </div>
                }
              />
            )}
          </div>

          <div className="flex gap-4">
            {props.createdAt && (
              <Metadata
                icon="fa-clock"
                value={<DateSpan value={props.createdAt} />}
                title={CREATED_AT}
              />
            )}
          </div>
        </div>
      </div>

      {props.reason && (
        <div className="flex flex-col gap-2">
          <h3>{REASON}</h3>
          <div className="text-sm text-muted break-words">{props.reason}</div>
        </div>
      )}

      {refusalReason && (
        <div className="flex flex-col gap-2">
          <h3>{REFUSAL_REASON}</h3>
          <div className="text-sm text-muted break-words">{refusalReasonLabel}</div>
        </div>
      )}

      {isMaternity && (
        <MaternityDetails {...((props as any).maternityLeave || props)} employee={props.employee} leave={props} />
      )}

      {props.files?.length > 0 && (
        <div className="flex flex-col gap-2">
          <h3>{ATTACHMENT}</h3>

          <div className="flex gap-4 flex-wrap">
            {props.files?.map((item, index) => (
              <a href={fileUrl(item.id)} target="_blank">
                <FileItem {...item} key={index} />
              </a>
            ))}
          </div>
        </div>
      )}

      {
        // canManageRequest && (
          <div className="flex justify-between gap-2">
            {
              canRefuse && (
            <Button
              className={`btn !bg-[#ff0000] !text-[#fff] ${disabledValidation ? '!opacity-50' : ''}`}
              startIcon="fa-circle-xmark"
              label={REFUSE}
              onClick={handleRefuse}
              disabled={disabledValidation}
                />
              )
            }
            <RefuseDayOffDialog
              open={refuseDialogOpen}
              onClose={() => setRefuseDialogOpen(false)}
              onConfirm={handleRefuseConfirm}
            />
            {canApprove && (
              <Button
                className={`btn !bg-[#0c60c0] !text-[#fff] ${disabledApprobation ? '!opacity-50' : ''}`}
                startIcon="fa-circle-check"
                label={APPROVE}
                onClick={handleApproveOrValidate}
                disabled={disabledApprobation}
              />
            )}
            {canValidate && (
              <Button
                className={`btn !bg-[#057a2c] !text-[#fff] ${disabledApprobation ? '!opacity-50' : ''}`}
                startIcon="fa-circle-check"
                label={VALIDATE}
                onClick={handleApproveOrValidate}
                disabled={
                  props?.status === "refused" ||
                  props?.status === "validated" ||
                  !hasApproved ||
                  !props?.id ||
                  validateMutation.isLoading
                }
              />
            )}
          </div>
        // )
      }

      <GenericSuspense>
        <Outlet />
      </GenericSuspense>
    </div>
  );
};

type Props = Partial<TTimeOff> & {
  toolbox?: ReactNode;
  disableDetailsQuery?: boolean;
};

// Mêmes codes que les options de useRefuseDayOffForm.
const REFUSAL_REASON_CODES = ["insufficient_balance", "not_eligible", "staffing_needs", "overlapping_request", "other"]

const i18n = [
  "std_creator",
  "std_status",
  "std_closed",
  "std_opened",
  "std_created_at",
  "BSMRH.Project.Dayoff.Demand.Date",
  "BSMRH.Calendar.TimeOff.Create.Form.Label.DateAppointmentBegin",
  "BSMRH.Calendar.TimeOff.Create.Form.Label.DateAppointmentEnd",
  "std_label",
  "Harea.Project.Calendar.Details.Users.Label",
  "Harea.Project.Calendar.Details.Description.Label",
  "std_justification",
  "std_metadata",
  "std_archived",
  "std_edit",
  "Harea.Project.Calendar.Details.Milestone.Label",
  "std_user",
  "Harea.Vacation.Calendar.Event.Create.Vacation.Form.Label.Repetition",
  "std_validate",
  "std_approve",
  "std_refuse",
  "std_print",
  "std_employee",
  "std_position",
  "std_solde_remainder",
  "std_total_days",
  "std_reason",
  "std_refusal_reason",
  "BSMRH.Project.Dayoff.Demand.Details.EmployeeDetails.Label",
  "std_total_hours",
  "std_remaining_annual_quota",
  "Harea.Project.DayOff.Validate.Error.Message",
  "Harea.Project.DayOff.Detail.PayrollDeductionAmount",
  "Harea.Project.DayOff.Detail.Treatment",
  "Harea.Project.DayOff.Detail.Treatment.Exception",
  "Harea.Project.DayOff.Detail.Treatment.Payroll",
  "Harea.Project.DayOff.Detail.Treatment.NegativeBalance"
];
